import { css } from '@emotion/react';
import { Theme } from '@mui/material/styles';

const GlobalStyles = (theme: Theme) => css`
  html,
  body,
  div#root {
    height: 100%;
  }
  html {
    background-color: ${theme.palette.background.default};
  }
  body {
    margin: 0;
    background: ${theme.customTokens.surfaces.pageBackdrop}, ${theme.palette.background.default};
    color: ${theme.palette.text.primary};
    font-family: ${theme.typography.fontFamily};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  * {
    box-sizing: border-box;
  }
  ::selection {
    background: ${theme.customTokens.overlays.selection};
  }
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 15px;
    height: 20px;
    max-height: 20px !important;
  }
  ::-webkit-scrollbar-thumb {
    background: ${theme.customTokens.overlays.scrollbarThumb};
    border-radius: 10px;
  }
  ::-webkit-scrollbar-corner {
    display: none;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${theme.customTokens.overlays.scrollbarThumbHover};
  }

  @media (max-width: 600px) {
    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
  }
`;

export default GlobalStyles;
